import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as HistoricalData from './HistoricalData';
import * as HistoricalRecordSearchStore from './HistoricalRecordSearchStore';
import * as TestDefinitions from './TestDefinitions';
import * as TestLogs from './TestLogs';
import * as TestLogsSampleData from './TestLogsSampleData';
import * as ScraperDetail from './ScraperDetailStore';
import * as Subscriptions from './SubscriptionStore';
import * as NotificationStore from './NotificationStore';
import * as JurisdictionStore from './JurisdictionStore';
import * as CaseTrackingStore from './CaseTrackingStore';
import * as SourceStatusStore from './SourceStatusStore';
import * as SourceFeedbackStore from './SourceFeedbackStore';
//import * as SourceCommunicationStore from './SourceCommunicationStore';
import * as ScraperDefinitionModels from './ScraperDefinitionModels';

export default function configureStore (history, initialState) {
  const reducers = {
      historicalData: HistoricalData.reducer,
      historicalRecordSearchReducer: HistoricalRecordSearchStore.reducer,
      testDefinitions: TestDefinitions.reducer,
      testLogs: TestLogs.reducer,
      testLogsSampleDataReducer: TestLogsSampleData.reducer,
      scraperDetail: ScraperDetail.reducer,
      scraperDefinitionModels: ScraperDefinitionModels.reducer,
      subscriptions: Subscriptions.reducer,
      notifications: NotificationStore.reducer,
      jurisdictions: JurisdictionStore.reducer,
      caseTracking: CaseTrackingStore.reducer,
      sourceStatus: SourceStatusStore.reducer,
      sourceFeedback: SourceFeedbackStore.reducer,
      //sourceCommunication: SourceCommunicationStore.reducer,
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
